import React, { useState, useEffect, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
// import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
// import MasterNumber from '../../YourInformation/components/MasterNumber'
// import PlateNumber from '../../YourInformation/components/PlateNumber'
// import VinSerialNumber from '../../YourInformation/components/VinSerialNumber'
import { clearListInfoAction, listAddAction } from 'redux/actions'
import moment from 'moment-timezone'
import Name from '../Name'
import JointMasterNumber from '../JointMasterNumber'
import { findDuplicateMasterNumber } from "../../../../../redux/reducers/appReducer";

// import styles from '../JointlyOwnedVehicleInformation.module.scss';

// import { processMasterNumberAction } from 'redux/reducers/apiReducers/processMasterNumberReducer'
// import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
// var unidecode = require('unidecode')
const AddJointlyOwnedVehicleView = ({ t, i18n, setIsError }) => {
    // const history = useHistory()
    const dispatch = useDispatch()

    const timezone = process.env.REACT_APP_TIME_ZONE.toString()
    moment.tz.setDefault(timezone)


    const [errMsg, setErrMsg] = useState('');
    const [nameValid, setNameValid] = useState('')
    const [jointMasterNumberValid, setJointMasterNumberValid] = useState('')

    const [nameError, setNameError] = useState('jointly_owned_vehicle_info.name_error')
    const [jointMasterNumberError, setJointMasterNumberError] = useState('jointly_owned_vehicle_info.joint_master_number_error')

    const { name, jointMasterNumber, vehicles } = useSelector((state) => state.app.jointlyOwnedVehicleInformation)

    const houseHoldMembers = useSelector((state) => state.app.personalInformation.houseHoldMembers);
    // const jointVehicles = useSelector((state) => state.app.jointlyOwnedVehicleInformation.vehicles);
    const businessVehicles = useSelector((state) => state.app.businessVehicleInformation.businessVehicles);

    useEffect(() => {
        try {
            dispatch(clearListInfoAction("jointlyOwnedVehicleInformation"))
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }, [dispatch, setIsError])

    const isDuplicate = useCallback((newVehicle) => {
        const foundDuplicate = findDuplicateMasterNumber(newVehicle.jointMasterNumber, houseHoldMembers, vehicles, businessVehicles);
        if (foundDuplicate) {
            setErrMsg('household_list.found_duplicate')
        } else {
            setErrMsg('')
        }
        return foundDuplicate
    }, [vehicles, setErrMsg, businessVehicles, houseHoldMembers]);

    const onAddJointlyOwnedVehicle = () => {
        try {
            const newVehicle = {
                name, jointMasterNumber
            };
            if (validateFields() && !isDuplicate(newVehicle)) {
                dispatch(listAddAction("jointlyOwnedVehicleInformation", newVehicle));
                dispatch(clearListInfoAction("jointlyOwnedVehicleInformation"))
                setJointMasterNumberValid('')
                setNameValid('')
                window.scrollTo(0, 0)
            }
        } catch (e) {
            console.log(e)
            // setErrMsg('your_information.service_not_available_error')
        }
    }


    const validateFields = () => {
        try {
            validateName(name)
            validateJointMasterNumber(jointMasterNumber)

            if (name === '') {
                setNameValid(false)
            }
            if (jointMasterNumber === '') {
                setJointMasterNumberValid(false)
            }

            return (
                nameValid === true &&
                jointMasterNumberValid === true &&

                name !== '' &&
                jointMasterNumber !== ''
            )
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    const validateName = (name) => {
        try {
            const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ& ]*$/)
            if (name.length > 0) {
                if (regex.test(name)) {
                    setNameValid(true)
                } else {
                    setNameValid(false)
                    setNameError('jointly_owned_vehicle_info.name_error_invalid')
                }
            } else {
                setNameValid(false)
                setNameError('jointly_owned_vehicle_info.name_error')
            }
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    const validateJointMasterNumber = (number) => {
        try {
            const regex = RegExp(/^[a-zA-Z\s]{5}[0-9]{9}$/i)
            if (regex.test(number)) {
                setJointMasterNumberValid(true)
            } else {
                setJointMasterNumberValid(false)
                setJointMasterNumberError('jointly_owned_vehicle_info.joint_master_number_error')
            }
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 col-lg-12">
                    <h2>{t('jointly_owned_vehicle_summary.or_add_another')}</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-lg-12">
                    <Name
                        validateName={validateName}
                        nameError={nameError}
                        nameValid={nameValid}
                        setIsError={setIsError}
                    />
                    <JointMasterNumber
                        validateJointMasterNumber={validateJointMasterNumber}
                        jointMasterNumberError={jointMasterNumberError}
                        jointMasterNumberValid={jointMasterNumberValid}
                        setIsError={setIsError}
                    />
                </div>
            </div>
            <div className="form-group has-error">
                <button
                    className="btn-lg btn-default"
                    // style={{ marginBottom: errMsg === '' ? '' : '5px' }}
                    onClick={onAddJointlyOwnedVehicle}
                    value={t('jointly_owned_vehicle_info.add_vehicle')}
                    name={t('jointly_owned_vehicle_info.add_vehicle')}
                >
                    {t('jointly_owned_vehicle_info.add_vehicle')}
                </button>{' '}
                {errMsg === '' ? '' : <i aria-label={t('shared.error')} className="fa fa-exclamation-circle" aria-hidden="true" />}
                <div className="help-block">{t(errMsg)}</div>
            </div>
        </React.Fragment>
    )
}

export default withTranslation('common')(AddJointlyOwnedVehicleView)
